export default __webpack_public_path__ + "static/media/transportation.88bf8825.jpg";